import utils from '@/mixins/utils'
const bookFilters = {
  mixins: [utils],
  data () {
    this.maxBooks = 1000 // default value for returned books
    return {
      sortOptions:
        {
          title: {
            reverse: true
          },
          author: {
            reverse: true
          },
          created: {
            reverse: true
          }
        },
      bulkActions:
      [
        {
          id: 'all',
          label: 'Select all'
        },
        {
          id: 'none',
          label: 'Select none'
        },
        {
          id: 'delete',
          label: 'Bulk delete'
        }
      ],
      selectedOption: '',
      searchBook: '',
      selectedState: 'all',
      params: {
        category: {
          id: 'all',
          label: 'Todas as categorias'
        },
        bulkAction: {
          id: '',
          label: 'Bulk Actions'
        }
      }
    }
  },
  computed: {
    filteredBooks () {
      if (this.reverseBooks) this.books = this.books.reverse()
      return this.books
        .filter(book => {
          return book.title.toLowerCase().includes(this.searchBook.toLowerCase())
        })
        .filter(() => {
          switch (this.selectedOption) {
            case 'title':
              return this.sortOptions.title.reverse ? this.posts.sort(this.sortAcs) : this.books.sort(this.sortAcs).reverse()
            case 'author':
              return this.sortOptions.author.reverse ? this.posts.sort(this.sortAcs) : this.books.sort(this.sortAcs).reverse()
            case 'created':
              return this.sortOptions.created.reverse ? this.posts.sort(this.sortAcs) : this.books.sort(this.sortAcs).reverse()
            default:
              return this.books
          }
        })
        .filter(book => {
          switch (this.params.category.id) {
            case 'all':
              return true
            default: {
              if (book.categories) {
                return book.categories.map(cat => {
                  return this.getId(cat)
                }).indexOf(this.params.category.id) > -1
              }
              // return this.getId(book.category) === this.params.category.id
            }
          }
        })
        .filter(book => {
          switch (this.selectedState) {
            case 'all':
              return true
            case 'saved':
              return book.state === 'saved'
            case 'published':
              return book.state === 'published'
          }
        }).splice(0, this.maxBooks)
    },
    booksList () {
      let list
      let dic = {}
      list = this.books.map(book => {
        if (book.hasOwnProperty('categories')) {
          return book.categories.map(cat => {
            if (cat) {
              // avoid duplicates
              if (!(cat in dic)) {
                dic[cat] = cat
                return {
                  id: this.getId(cat),
                  label: cat
                }
              }
            }
          })
        }
      }).reduce(function (a, b) {
        return a.concat(b)
      }, []).filter(function (n) { return n !== undefined })
      list.push({
        id: 'all',
        label: 'Todas as categorias'
      })
      return list
    },
    selectedPosts () {
      return this.filteredPosts.filter(post => {
        if (post.selected) {
          return true
        }
      })
    }
  },
  methods: {
    sortAcs (a, b) {
      if (this.selectedOption === 'created') {
        if (a[this.selectedOption] < b[this.selectedOption]) {
          return -1
        }
        if (a[this.selectedOption] > b[this.selectedOption]) {
          return 1
        }
      } else {
        if (a[this.selectedOption].toLowerCase() < b[this.selectedOption].toLowerCase()) {
          return -1
        }
        if (a[this.selectedOption].toLowerCase() > b[this.selectedOption].toLowerCase()) {
          return 1
        }
      }
      return 0
    },
    sortBy (option) {
      switch (option) {
        case 'title':
          this.selectedOption = 'title'
          this.sortOptions.title.reverse = !this.sortOptions.title.reverse
          break
        case 'author':
          this.selectedOption = 'author'
          this.sortOptions.author.reverse = !this.sortOptions.author.reverse
          break
        case 'created':
          this.selectedOption = 'created'
          this.sortOptions.created.reverse = !this.sortOptions.created.reverse
          break
      }
    },
    selectBulkActions () {
      var i = this.filteredPosts.length
      while (i--) {
        if (this.params.bulkAction.id === 'all') {
          this.filteredPosts[i].selected = true
        }
        if (this.params.bulkAction.id === 'none') {
          this.filteredPosts[i].selected = false
        }
        if (this.params.bulkAction.id === 'delete') {
          if (this.filteredPosts[i].selected === true) {
            this.$firebaseRefs.posts.child(this.filteredPosts[i]['.key']).remove().then(() => {
              // this.showNotification('success', 'Posts deleted successfully')
              // this.showModal = false
            })
          }
        }
      }
      this.showModal = false
    }
  }
}
export default bookFilters



// WEBPACK FOOTER //
// ./src/mixins/bookFilters.js